<template>
  <section :class="rootStyles">
    <div :class="{ [$style.fit_content]: !beforeRenewalStyle }">
      <div :class="[$style.text, { 'page-parts-pc': spText }]" v-html="sanitizeHtmlContent(text)" />
      <div v-if="spText" class="page-parts-sp" :class="$style.text" v-html="sanitizeHtmlContent(spText)" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { sanitizeHtmlContent } from "@tential/ec-gql-schema/utils/functions/sanitize"

const props = withDefaults(
  defineProps<{
    text: string
    spText?: string

    /**
     * リニューアル前のスタイル(before_renewal_style)を有効にする(default: true)
     */
    beforeRenewalStyle?: boolean
  }>(),
  {
    spText: undefined,
    beforeRenewalStyle: true,
  },
)

const style = useCssModule()
const rootStyles = computed(() => {
  return props.beforeRenewalStyle ? [style.container, "parts-container", style.before_renewal_style] : style.container
})
</script>

<style module lang="scss">
.container {
  .fit_content {
    width: fit-content;
  }

  .text {
    text-align: left;
    font-size: $font-size-16;

    @include sp {
      font-size: $font-size-14;
    }

    // v-html 内に挿入されるテキストエディタ系のスタイル調整
    :global {
      // マーカー系
      .blue-marker {
        border-bottom: 4px solid #cadffd;
      }
      .red-marker {
        border-bottom: 4px solid #ffb8b9;
      }
      .yellow-marker {
        border-bottom: 4px solid #fefd9c;
      }

      // 箇条書き list-style の始まり位置調整
      ul {
        padding-left: 1.25rem;
      }
    }
  }

  :global(img) {
    max-width: 100%;
  }
}

// リニューアル前から残っている padding の設定
.before_renewal_style {
  @include container-md;
}
</style>
